import { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Utensils, Lock, Mail } from "lucide-react";
import { toast } from "sonner";

const BG_URL =
  "https://static.prod-images.emergentagent.com/jobs/a5a93b2e-4bcc-4b24-89da-310adedd8d1c/images/8f461d96ff12f29153ce6dc87dae15f7571d04a9f4fefdfcb4e6bbe7a903e519.png";

export default function Login() {
  const { user, login, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@restaurant.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (error) toast.error(error);
  }, [error]);

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) {
      toast.success("Welcome back!");
      nav("/");
    }
  };

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-4"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(249,248,246,0.92), rgba(249,248,246,0.7)), url(${BG_URL})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="login-page"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-xl bg-[#D95D39] flex items-center justify-center text-white shadow-sm">
            <Utensils size={22} strokeWidth={2} />
          </div>
          <div>
            <div className="font-heading font-extrabold text-2xl tracking-tight text-[#2D2C2A]">
              Thali POS
            </div>
            <div className="text-sm text-[#7A7873]">Restaurant billing, simplified.</div>
          </div>
        </div>

        <div className="bg-white border border-[#EBE8E2] rounded-xl p-8 shadow-sm">
          <h1 className="font-heading font-bold text-2xl text-[#2D2C2A] mb-1">Sign in</h1>
          <p className="text-sm text-[#7A7873] mb-6">Welcome back. Please enter your credentials.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-sm text-[#2D2C2A] font-medium">Email</Label>
              <div className="mt-1.5 relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-[#7A7873]" size={16} />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="pl-9 h-11 border-[#EBE8E2] focus-visible:ring-[#D95D39]"
                  data-testid="login-email-input"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="password" className="text-sm text-[#2D2C2A] font-medium">Password</Label>
              <div className="mt-1.5 relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-[#7A7873]" size={16} />
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="pl-9 h-11 border-[#EBE8E2] focus-visible:ring-[#D95D39]"
                  data-testid="login-password-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full h-11 bg-[#D95D39] hover:bg-[#C24F2C] text-white font-semibold tracking-wide active:scale-[0.98] transition"
            >
              {loading ? "Signing in..." : "Sign in"}
            </Button>
          </form>

          <div className="mt-6 p-3 rounded-lg bg-[#F4F2EE] text-xs text-[#7A7873] leading-relaxed">
            <div className="font-semibold text-[#2D2C2A] mb-1">Demo accounts</div>
            <div>Admin: admin@restaurant.com / admin123</div>
            <div>Manager: manager@restaurant.com / password123</div>
            <div>Cashier: cashier@restaurant.com / password123</div>
          </div>
        </div>

        <div className="text-center text-xs text-[#7A7873] mt-6">
          © 2026 Thali POS · Made for Indian restaurants
        </div>
      </div>
    </div>
  );
}
